import { useMutation } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import {
  CreateOrUpdateInternalCandidacyCommentRequest,
  HttpResponse,
  InternalCandidacyComment,
} from "@/types";

export function useCreateInternalCandidacyComment() {
  const mutation = useMutation({
    mutationFn: async ({
      candidacyId,
      createInternalCandidacyCommentRequest,
      currentCompanyId,
      currentJobId,
    }: {
      candidacyId: string;
      createInternalCandidacyCommentRequest: CreateOrUpdateInternalCandidacyCommentRequest;
      currentCompanyId: string;
      currentJobId: string;
    }) => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/candidacies/${candidacyId}/internal-candidacy-comments`;
      const res = await guacHttpClient.post<
        InternalCandidacyComment,
        HttpResponse<InternalCandidacyComment>,
        CreateOrUpdateInternalCandidacyCommentRequest
      >(path, createInternalCandidacyCommentRequest);

      return res.data;
    },
  });

  return mutation;
}
